export const CONTRACT_TYPE_OPTIONS = [
    { label: "CDI", value: "CDI" },
    { label: "CDD", value: "CDD" },
    { label: "Stage", value: "STAGE" },
]


    